function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var showQuickAddError = function showQuickAddError(button, message) {
  const note = document.createElement('p');
  note.className = 'form-notification error';
  note.setAttribute('role', 'alert');
  note.textContent = message || theme.strings.cartError;
  button.after(note);
  setTimeout(() => note.remove(), 5000);
};
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

const FETCH_CONFIG = {
  method: 'POST',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/javascript'
  }
};

const OverlayManager = {
  stack: [],
  beforeCloseHandlers: new Map(),
  cc: null,

  getCC() {
    if (!this.cc) {
      this.cc = document.querySelector('.click-capture');
    }
    return this.cc;
  },

  updateCCZIndex() {
    let cc = this.getCC();
    if (!cc) return;
    if (this.stack.length > 1) {
      let topPanel = this.stack[this.stack.length - 1];
      let topZ = parseInt(getComputedStyle(topPanel).zIndex, 10) || 90;
      cc.style.zIndex = topZ - 1;
    } else {
      cc.style.zIndex = '';
    }
  },

  open(panel) {
    if (!panel) return;
    // If already in stack, move to top
    const index = this.stack.indexOf(panel);
    if (index > -1) this.stack.splice(index, 1);
    this.stack.push(panel);
    // Remember what opened the panel so closing it can hand focus back, but only when it was opened from the
    // keyboard (:focus-visible): after a mouse click the theme's .button:focus colour would otherwise stay on.
    const opener = document.activeElement;
    if (opener && opener !== document.body && !panel.contains(opener) && opener.matches(':focus-visible')) panel._opener = opener;
    panel.classList.add('active');
    panel.inert = false;
    document.body.classList.add('open-cc');
    this.updateCCZIndex();
    panel.querySelector('.side-panel-close')?.focus();
    dispatchCustomEvent('panel:open', { panel });
  },

  close(panel) {
    if (!panel) return;
    const index = this.stack.indexOf(panel);
    if (index > -1) this.stack.splice(index, 1);
    if (!this.stack.length) {
      document.body.classList.remove('open-cc');
    }
    this.updateCCZIndex();
    panel.classList.remove('active');
    panel.inert = true;
    if (panel._opener && panel._opener.isConnected) panel._opener.focus({ preventScroll: true });
    panel._opener = null;
    dispatchCustomEvent('panel:closed', { panel });

    const handler = this.beforeCloseHandlers.get(panel);
    if (handler) handler();
  },

  closeLast() {
    const panel = this.stack[this.stack.length - 1];
    if (panel) this.close(panel);
  },

  registerBeforeClose(panel, handler) {
    this.beforeCloseHandlers.set(panel, handler);
  },

  closeAll() {
    while (this.stack.length) {
      this.closeLast();
    }
  },

  isOpen(panel) {
    return this.stack.includes(panel);
  },

  hasOpen() {
    return this.stack.length > 0;
  }
};

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

      this.validateQtyRules();
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }

      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}


/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      let cachedWidth = 0;
      let currentIndex = -1;
      let rafId = null;

      const updateHover = (e) => {
        let l = e.offsetX;
        let prc = l / cachedWidth;
        let sel = Math.floor(prc * image_length);
        // Backported from Vision 17.0.0. Touch events carry no offsetX, so sel
        // comes out NaN. Every comparison against NaN is false, so it slid past
        // the three checks below and reached images[NaN] -> undefined ->
        // .classList threw. Non-finite means there is nothing to hover.
        if (!Number.isFinite(sel) || sel === currentIndex || sel < 0 || sel >= image_length) return;
        if (currentIndex >= 0) {
          images[currentIndex].classList.remove('hover');
          if (nav.length) nav[currentIndex].classList.remove('active');
        }
        currentIndex = sel;
        images[sel].classList.add('hover');
        if (nav.length) nav[sel].classList.add('active');
      };

      const mousemove = (e) => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = null;
          updateHover(e);
        });
      };

      const mouseenter = (e) => {
        cachedWidth = image_container.getBoundingClientRect().width;
        updateHover(e);
      };

      const mouseleave = () => {
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        if (currentIndex >= 0) {
          images[currentIndex].classList.remove('hover');
          if (nav.length) nav[currentIndex].classList.remove('active');
          currentIndex = -1;
        }
      };

      if (image_container) {
        image_container.addEventListener('touchstart', mouseenter, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mouseenter, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      if (document.readyState === 'complete') {
        images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      } else {
        window.addEventListener('load', () => {
          images.forEach(function (image) {
            lazySizes.loader.unveil(image);
          });
        }, { once: true });
      }
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';

      const unveilSwatches = () => {
        swatch_list.forEach((swatch) => {
          let img = new Image();
          img.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(img);
        });
      };
      if (document.readyState === 'complete') {
        unveilSwatches();
      } else {
        window.addEventListener('load', unveilSwatches, { once: true });
      }

      swatches.addEventListener('mouseover', (e) => {
        let swatch = e.target.closest('.product-card-swatch');
        if (!swatch) return;
        let active = swatches.querySelector('.product-card-swatch.active');
        if (active) active.classList.remove('active');
        swatch.classList.add('active');
        if (image) {
          image.setAttribute('srcset', swatch.dataset.srcset || org_srcset);
        }
      });

      swatches.addEventListener('click', (e) => {
        let swatch = e.target.closest('.product-card-swatch');
        if (!swatch) return;
        e.preventDefault();
        window.location.href = swatch.dataset.href;
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      fetch(`${theme.routes.cart_add_url}`, { ...FETCH_CONFIG, body: formData })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            showQuickAddError(this.quick_add, response.description);
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
          showQuickAddError(this.quick_add);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      /*
        parsedState.sections was read unguarded here, the same way product.js
        used to. Any add that comes back without a `sections` object - Aris
        Product Options completes some adds itself - threw on the first
        iteration, which meant the cartDrawer.open() below never ran and the
        customer saw nothing happen at all.
      */
      const sections = parsedState && parsedState.sections;
      const added_keys = (function () {
        if (!parsedState) return [];
        const items = Array.isArray(parsedState.items) ? parsedState.items : [parsedState];
        return items.map((item) => item && item.key).filter(Boolean);
      }());

      if (sections) {
        this.getSectionsToRender().forEach((section => {
          const el = document.getElementById(section.id);
          if (!el) return;
          const innerHTML = this.getSectionInnerHTML(sections[section.section], section.selector);
          if (innerHTML === null) return;
          const elementToReplace = el.querySelector(section.selector) || el;
          elementToReplace.innerHTML = innerHTML;


          if (typeof Cart !== 'undefined') {
            new Cart().renderContents(parsedState);
          }
        }));
      } else {
        const el = document.getElementById('Cart-Drawer');
        if (el && typeof el.refresh === 'function') {
          el.refresh();
        }
      }

      let cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        let productDrawer = document.getElementById('Product-Drawer');
        if (productDrawer && OverlayManager.isOpen(productDrawer)) {
          OverlayManager.close(productDrawer);
        }
        cartDrawer.open();
        if (typeof cartDrawer.verifyAfterAdd === 'function') {
          cartDrawer.verifyAfterAdd(added_keys);
        }
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      // Null instead of throwing: one missing section must not abort the rest,
      // including the code that opens the drawer.
      if (!html) return null;
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? el.innerHTML : null;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }
    setEventListeners() {
      this.button.addEventListener('click', this.addToCart.bind(this));
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    addToCart() {
      this.button.classList.add('loading');
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);

      let formData = new FormData(this.form);

      formData.append('id', this.id);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      fetch(`${theme.routes.cart_add_url}`, { ...FETCH_CONFIG, body: formData })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            showQuickAddError(this.button, response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
          showQuickAddError(this.button);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        });
    }
    renderContents(parsedState) {
      /*
        parsedState.sections was read unguarded here, the same way product.js
        used to. Any add that comes back without a `sections` object - Aris
        Product Options completes some adds itself - threw on the first
        iteration, which meant the cartDrawer.open() below never ran and the
        customer saw nothing happen at all.
      */
      const sections = parsedState && parsedState.sections;
      const added_keys = (function () {
        if (!parsedState) return [];
        const items = Array.isArray(parsedState.items) ? parsedState.items : [parsedState];
        return items.map((item) => item && item.key).filter(Boolean);
      }());

      if (sections) {
        this.getSectionsToRender().forEach((section => {
          const el = document.getElementById(section.id);
          if (!el) return;
          const innerHTML = this.getSectionInnerHTML(sections[section.section], section.selector);
          if (innerHTML === null) return;
          const elementToReplace = el.querySelector(section.selector) || el;
          elementToReplace.innerHTML = innerHTML;


          if (typeof Cart !== 'undefined') {
            new Cart().renderContents(parsedState);
          }
        }));
      } else {
        const el = document.getElementById('Cart-Drawer');
        if (el && typeof el.refresh === 'function') {
          el.refresh();
        }
      }
      let cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        let productDrawer = document.getElementById('Product-Drawer');
        if (productDrawer && OverlayManager.isOpen(productDrawer)) {
          OverlayManager.close(productDrawer);
        }
        cartDrawer.open();
        if (typeof cartDrawer.verifyAfterAdd === 'function') {
          cartDrawer.verifyAfterAdd(added_keys);
        }
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      // Null instead of throwing: one missing section must not abort the rest,
      // including the code that opens the drawer.
      if (!html) return null;
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? el.innerHTML : null;
    }
  }
  customElements.define('product-card-small', ProductCardSmall);
}

/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    connectedCallback() {
      // Each instance gets its own click handler
      this.addEventListener('click', (e) => this.close_panel(e));
      // It is a custom element, not a <button>: the markup gives it role/tabindex, this gives it Enter/Space.
      this.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') this.close_panel(e); });

      // Global listeners only once
      if (!PanelClose._initialized) {
        PanelClose._initialized = true;
        document.addEventListener('keyup', (e) => {
          if (e.code && e.code.toUpperCase() === 'ESCAPE') {
            OverlayManager.closeAll();
          }
        });
        let cc = document.querySelector('.click-capture');
        if (cc) {
          cc.addEventListener('click', () => {
            OverlayManager.closeLast();
          });
        }
      }
    }

    close_panel(e) {
      e.preventDefault();
      let panel = e.target.closest('.side-panel');
      if (panel) {
        OverlayManager.close(panel);
      }
    }
  }
  PanelClose._initialized = false;
  customElements.define('side-panel-close', PanelClose);
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');


      // Add functionality to buttons
      button?.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      // One timer per input: a shared one dropped the first of two quick changes on different lines.
      this.addEventListener('change', (event) => {
        clearTimeout(event.target.changeTimer);
        event.target.changeTimer = setTimeout(() => this.onChange(event), 300);
      });

    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value, event.target.closest('quantity-selector').dataset.id);
      }
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      // Null instead of throwing: one missing section must not abort the rest,
      // including the code that opens the drawer.
      if (!html) return null;
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? el.innerHTML : null;
    }
    updateQuantity(line, quantity, key) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      // By key, not line number: lines renumber when an earlier change lands, and the wrong set would go.
      const body = JSON.stringify({
        id: key,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      // One at a time: Shopify keeps only one of two changes sent together.
      this.changes = (this.changes || Promise.resolve()).then(() => fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          // A refused change (422, e.g. more than in stock) has no sections, only a description.
          if (!parsedState.sections) throw new Error(parsedState.description || theme.strings.cartError);

          this.getSectionsToRender().forEach((section => {
            const el = document.getElementById(section.id);
            if (!el) return;
            const elementToReplace = el.querySelector(section.selector) || el;

            // innerHTML = null would empty the drawer.
            const innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            if (innerHTML !== null) elementToReplace.innerHTML = innerHTML;
          }));

          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });
          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
          // The cart page can sit behind the drawer.
          if (typeof Cart !== 'undefined') new Cart().refresh();
        })
        // Network failure or a rate-limit page: put the real quantities back and say so, instead of spinning forever.
        .catch((error) => {
          const message = error instanceof SyntaxError || error instanceof TypeError ? theme.strings.cartError : error.message;
          const showError = () => {
            const item = [...this.querySelectorAll('quantity-selector')].find((q) => q.dataset.id === key)?.closest('[id^="CartDrawerItem-"]');
            if (!item) return;
            item.classList.remove('thb-loading');
            const note = document.createElement('p');
            note.className = 'form-notification error';
            note.setAttribute('role', 'alert');
            note.textContent = message;
            item.after(note);
          };
          return this.refresh().then(showError, showError);
        }));
    }
    open() {
      OverlayManager.open(this);
      dispatchCustomEvent('cart-drawer:open');
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      /*
        Cache-busted on purpose. This URL is otherwise byte-identical on every
        call, so the browser is free to hand back the response it already has -
        which is exactly the stale drawer we are trying to replace. Without this
        the retry loop can fetch the same outdated markup four times in a row
        and look like it did nothing.
      */
      return fetch(`${window.location.pathname}?sections=${sections}&_=${Date.now()}`, {
        cache: 'no-store',
        headers: { 'Accept': 'text/html' }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const el = document.getElementById(section.id);
            if (!el) return;
            const elementToReplace = el.querySelector(section.selector) || el;

            const innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
            if (innerHTML === null) return;
            elementToReplace.innerHTML = innerHTML;
          }));

        });
    }
    /*
      Shared safety net for the quick-add paths in this file. Same check as
      product.js: rather than trusting that the drawer re-rendered, ask whether
      it is actually showing the line we just added. Each line prints its key as
      data-id and the add response gives us that key, so this is a DOM lookup -
      no /cart.js call, which matters because that endpoint is rate limited and
      already busy with Shopify's own shop_events_listener and Rebuy.

      Catches both ways the drawer goes stale: a response with no sections at
      all, and a response whose section markup was rendered from a cart snapshot
      taken just before the add committed.
    */
    verifyAfterAdd(added_keys, attempt = 0) {
      if (!added_keys || !added_keys.length) return;

      const missing = added_keys.some((key) => !this.querySelector(`[data-id="${key}"]`));
      if (!missing) {
        if (attempt > 0) console.log('[cart-verify] 抽屉已补上，重试第 %d 次后恢复', attempt);
        return;
      }

      const MAX_ATTEMPTS = 4;
      if (attempt >= MAX_ATTEMPTS) {
        console.log('[cart-verify] 重试 %d 次仍未出现，放弃', MAX_ATTEMPTS, added_keys);
        return;
      }
      console.log('[cart-verify] 抽屉缺少刚加的商品，第 %d 次重拉', attempt + 1, added_keys);

      /*
        Waiting on the refresh instead of running down a fixed timer. The first
        version fired its checks at 0/250/850/2050ms regardless of whether any
        refresh had come back yet - on a slow connection a section fetch takes
        seconds, so all four checks could complete before the first response
        landed. The drawer then corrected itself a moment later, after we had
        already given up, which is why the log showed four failures and no
        recovery even though the cart looked right.
      */
      const again = () => setTimeout(() => this.verifyAfterAdd(added_keys, attempt + 1), 150);
      const pending = this.refresh();
      if (pending && typeof pending.then === 'function') {
        pending.then(again).catch(again);
      } else {
        again();
      }
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}


/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      };
      this.autoClose = this.dataset.autoClose;
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this));
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.detailsements.panel.querySelectorAll('button').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('custom-select--active');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.detailsements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.detailsements.input.value = event.currentTarget.dataset.value;
      this.detailsements.input.dispatchEvent(new Event('change'));
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent;
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'));
      }
      if (this.autoClose) {
        this.classList.remove('custom-select--active');
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle('custom-select--active');
      if (this.classList.contains('custom-select--active')) {
        this.detailsements.button.focus();
        this.detailsements.button.setAttribute('aria-expanded', (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString());
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('custom-select', CustomSelect);
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('input[name="locale_code"], input[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
          e.preventDefault();
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');

      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  const _cache = new Map();

  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.drawerContent = this.drawer.querySelector('#Product-Drawer-Content');

      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);

      OverlayManager.registerBeforeClose(this.drawer, () => {
        document.body.classList.remove('open-cc--product');
        setTimeout(() => {
          if (!this.drawer.classList.contains('active')) {
            this.drawerContent.innerHTML = '';
          }
        }, 260);
      });
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }
    _onClick(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle;
      if (!productHandle || this.classList.contains('loading')) {
        return;
      }

      let href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;
      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');

      if (_cache.has(productHandle)) {
        this.renderQuickview(_cache.get(productHandle), href, productHandle);
        return;
      }

      this.classList.add('loading');
      fetch(href)
        .then((response) => response.text())
        .then((text) => {
          this.classList.remove('loading');
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          _cache.set(productHandle, sectionInnerHTML);
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        })
        .catch(() => {
          this.classList.remove('loading');
        });
    }
    _reloadScripts(container) {
      let scripts = container.querySelectorAll('script');
      let head = document.head;
      scripts.forEach((oldScript) => {
        let newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });
        if (oldScript.src) {
          if (document.querySelector(`script[src="${oldScript.src}"]`)) {
            return;
          }
        } else {
          newScript.textContent = oldScript.textContent;
        }
        if (oldScript.parentNode) {
          oldScript.parentNode.replaceChild(newScript, oldScript);
        } else {
          head.appendChild(newScript);
        }
      });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (!sectionInnerHTML) {
        return;
      }

      let drawerContent = this.drawer.querySelector('#Product-Drawer-Content');
      drawerContent.innerHTML = sectionInnerHTML;

      this._reloadScripts(drawerContent);

      OverlayManager.open(this.drawer);
      document.body.classList.add('open-cc--product');

      requestAnimationFrame(() => {
        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        if (window.ProductModel) {
          window.ProductModel.loadShopifyXR();
        }
        let slider = this.drawer.querySelector('#Product-Slider');
        if (slider) {
          slider.reInit();
        }
        window.dispatchEvent(new Event('resize'));
      });

      dispatchCustomEvent('quick-view:open', {
        productUrl: href,
        productHandle: productHandle
      });

      addIdToRecentlyViewed(productHandle);
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {

  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path');
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: "0%",
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%'
        }
      });
    });
  }

}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {

  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers();
  }

});
// Enter on a product option (size radio, select, checkbox, text field) used to submit the add-to-cart form
// it belongs to through the form="" attribute, adding a half-chosen set for keyboard and screen-reader users.
// Enter now only picks the option; the order goes in from the add-to-cart button.
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Enter' || e.isComposing) return;
  const t = e.target;
  if (!t.matches || !t.matches('input:not([type="submit"]):not([type="button"]):not([type="image"]), select')) return;
  const action = t.form ? t.form.getAttribute('action') || '' : '';
  if (/\/cart\/add/.test(action)) {
    e.preventDefault();
    if (t.type === 'radio') t.click();
  } else if (/\/cart\/?$/.test(action) && t.classList.contains('qty')) {
    // On the cart page Enter in a quantity box went straight to checkout (the form's only submit button).
    e.preventDefault();
    t.dispatchEvent(new Event('change', { bubbles: true }));
  }
}, true);

// Keep Tab inside an open drawer that says it is modal (cart drawer, quick-add drawer): without this, Tab walked
// out of the drawer into the page behind it, which a screen-reader user cannot see is still covered.
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Tab') return;
  const open = [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].filter((d) => !d.inert && d.getClientRects().length && (d.classList.contains('active') || d.open));
  const dlg = open[open.length - 1];
  if (!dlg) return;
  const items = [...dlg.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])')]
    .filter((el) => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  if (!items.length) { e.preventDefault(); dlg.focus(); return; }
  const first = items[0], last = items[items.length - 1];
  if (!dlg.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  else if (e.shiftKey && (document.activeElement === first || document.activeElement === dlg)) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
});

// Pause / play for self-moving content (snippets/joyee-motion-toggle.liquid). Starts paused when the
// visitor asked the system for reduced motion; JS tickers check .is-motion-paused on their host.
// Capture phase + stopPropagation: the button sits inside clickable media (product zoom, card links).
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-motion-toggle]');
  if (!btn) return;
  e.stopPropagation();
  const paused = btn.getAttribute('aria-pressed') !== 'true';
  btn.setAttribute('aria-pressed', paused);
  const host = btn.closest('.joyee-motion-host');
  host.classList.toggle('is-motion-paused', paused);
  host.querySelectorAll('video').forEach((v) => (paused ? v.pause() : v.play().catch(() => {})));
  // Carousels that advance by themselves (Flickity autoPlay) and the background-video section's own player.
  [host, ...host.querySelectorAll('.flickity-enabled')].forEach((el) => {
    const f = window.Flickity && Flickity.data(el);
    if (f && f.options.autoPlay) (paused ? f.stopPlayer() : f.playPlayer());
  });
  if (typeof host.videoPause === 'function') (paused ? host.videoPause() : host.videoPlay());
}, true);
// Section scripts restart videos (back in view, slide change); a paused host keeps them paused. Videos outside
// any host (product card videos, the Instagram row) follow the footer's site-wide switch instead.
document.addEventListener('play', (e) => {
  if (!e.target.closest) return;
  const host = e.target.closest('.joyee-motion-host');
  if (host ? host.classList.contains('is-motion-paused') : document.documentElement.classList.contains('joyee-motion-off')) e.target.pause();
}, true);

// Footer "Pause animations": one switch for the whole site, remembered in this browser. It presses every pause
// button on the page, stops the announcement rotation and the videos that have no button of their own.
const JOYEE_MOTION_KEY = 'joyee-motion-off';
const joyeeSetAllMotion = (off) => {
  document.documentElement.classList.toggle('joyee-motion-off', off);
  try { off ? localStorage.setItem(JOYEE_MOTION_KEY, '1') : localStorage.removeItem(JOYEE_MOTION_KEY); } catch (e) {}
  document.querySelectorAll('[data-motion-all]').forEach((b) => b.setAttribute('aria-pressed', off));
  document.querySelectorAll('[data-motion-toggle]').forEach((b) => { if ((b.getAttribute('aria-pressed') === 'true') !== off) b.click(); });
  document.querySelectorAll('[data-joyee-announcement-toggle]').forEach((b) => { if ((b.getAttribute('data-playing') !== 'false') === off) b.click(); });
  document.querySelectorAll('video').forEach((v) => {
    if (v.closest('.joyee-motion-host')) return;
    if (off) v.pause();
    else if (v.closest('card-video.is-playing, .jig-card.is-playing')) v.play().catch(() => {});
  });
};
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-motion-all]');
  if (btn) joyeeSetAllMotion(btn.getAttribute('aria-pressed') !== 'true');
});

// Safety net for WCAG 2.2.2: anything that starts moving by itself outside a section that already has a pause
// button (say a section whose autoplay is switched on in the editor later) gets one, copied from the template
// in layout/theme.liquid. Product card videos are the agreed exception.
const joyeeAddMotionToggle = (host, before, isStatic) => {
  const tpl = document.getElementById('JoyeeMotionToggle');
  if (!tpl || host.closest('.joyee-motion-host')) return;
  host.classList.add('joyee-motion-host');
  host.setAttribute('data-motion-auto', '');
  if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
  const btn = tpl.content.firstElementChild.cloneNode(true);
  if (isStatic) btn.classList.replace('joyee-motion-toggle--corner', 'joyee-motion-toggle--static');
  host.insertBefore(btn, before || null);
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.classList.contains('joyee-motion-off')) btn.click();
};
// 'playing', not 'play': by then the duration is known, so a long one-shot video is caught too.
document.addEventListener('playing', (e) => {
  const v = e.target;
  if (!(v instanceof HTMLVideoElement) || v.controls || v.closest('card-video, .joyee-motion-host, [data-motion-exempt]')) return;
  if (!v.loop && !(v.duration > 5)) return;
  // A button can't sit inside a link: put it beside the link instead.
  const link = v.closest('a');
  joyeeAddMotionToggle(link ? link.parentElement : v.parentElement, link ? link.nextSibling : null);
}, true);
const joyeeCheckCarousels = () => {
  if (!window.Flickity) return;
  document.querySelectorAll('.flickity-enabled').forEach((el) => {
    const f = Flickity.data(el);
    if (!f || !f.options.autoPlay || el.closest('.joyee-motion-host, [data-motion-exempt]')) return;
    // Outside the slider: Flickity makes every child of it a slide.
    joyeeAddMotionToggle(el.parentElement, el.nextSibling, true);
  });
};
window.addEventListener('load', () => setTimeout(joyeeCheckCarousels, 1500));
document.addEventListener('shopify:section:load', () => setTimeout(joyeeCheckCarousels, 1500));
const joyeePauseForReducedMotion = () => {
  let off = false;
  try { off = localStorage.getItem(JOYEE_MOTION_KEY) === '1'; } catch (e) {}
  if (off) return joyeeSetAllMotion(true);
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('[data-motion-toggle][aria-pressed="false"]').forEach((btn) => btn.click());
};
document.addEventListener('DOMContentLoaded', joyeePauseForReducedMotion);
document.addEventListener('shopify:section:load', joyeePauseForReducedMotion);

// The cart drawer and cart page re-render by swapping HTML, which removed the focused control (quantity
// buttons, the offer code button) and dropped keyboard and screen-reader focus to <body> with no word
// on what changed. Remember the focused control, refocus its replacement, and announce the new state.
(() => {
  const SCOPE = '#Cart-Drawer, #Cart';
  let last = null;
  const keyOf = (el) => {
    if (el.id) return '#' + CSS.escape(el.id);
    for (const a of ['aria-label', 'data-code', 'name']) {
      if (el.getAttribute(a)) return `${el.tagName.toLowerCase()}[${a}="${CSS.escape(el.getAttribute(a))}"]`;
    }
    return null;
  };
  const status = document.createElement('div');
  status.className = 'visually-hidden';
  status.setAttribute('role', 'status');
  if (document.body) document.body.appendChild(status);
  else document.addEventListener('DOMContentLoaded', () => document.body.appendChild(status));
  const announce = (scope) => {
    const msg = scope.querySelector('.joyee-offer__msg');
    const total = scope.querySelector('.cart-total');
    const parts = [msg && msg.innerText.trim()];
    // The total cell can hold the original and the discounted price; the last amount is what they pay.
    const money = total && [...total.querySelectorAll('.money, .amount')].pop();
    if (total) parts.push([total.querySelector('th') && total.querySelector('th').firstChild.textContent.trim(), money && money.innerText.trim()].join(' '));
    status.textContent = '';
    setTimeout(() => { status.textContent = parts.filter(Boolean).join('. '); }, 100);
  };
  document.addEventListener('focusin', (e) => {
    const scope = e.target.closest(SCOPE);
    last = scope ? { el: e.target, scope: '#' + scope.id, key: keyOf(e.target) } : null;
  });
  new MutationObserver(() => {
    if (!last || last.el.isConnected || document.activeElement !== document.body) return;
    const scope = document.querySelector(last.scope);
    if (!scope || !scope.checkVisibility()) { last = null; return; }
    // The cart page has phone and desktop copies of each control with the same label; take the one on screen.
    const next = (last.key && [...scope.querySelectorAll(last.key)].find((el) => el.checkVisibility())) || scope.querySelector('.side-panel-close, a[href], button');
    if (!next) return;
    next.focus();
    announce(scope);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

// Desktop menu dropdowns open on hover or focus (CSS). Say so with aria-expanded, and let Escape close one
// without moving the pointer or focus (WCAG 1.4.13); it can open again once focus or the pointer leaves the item.
(() => {
  const ITEM = '.thb-full-menu > li.menu-item-has-children';
  const linkOf = (li) => li.querySelector(':scope > .thb-full-menu--link');
  const setOpen = (li, open) => { const a = linkOf(li); if (a) a.setAttribute('aria-expanded', open); };
  const init = () => document.querySelectorAll(ITEM).forEach((li) => {
    if (linkOf(li) && !linkOf(li).hasAttribute('aria-expanded')) setOpen(li, false);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('focusin', (e) => {
    const li = e.target.closest(ITEM);
    if (li && !li.classList.contains('is-dismissed')) setOpen(li, true);
  });
  document.addEventListener('focusout', (e) => {
    const li = e.target.closest(ITEM);
    if (li && !li.contains(e.relatedTarget)) { li.classList.remove('is-dismissed'); setOpen(li, false); }
  });
  document.addEventListener('mouseover', (e) => {
    const li = e.target.closest && e.target.closest(ITEM);
    if (li && !li.classList.contains('is-dismissed')) setOpen(li, true);
  });
  document.addEventListener('mouseout', (e) => {
    const li = e.target.closest && e.target.closest(ITEM);
    if (li && !li.contains(e.relatedTarget) && !li.contains(document.activeElement)) { li.classList.remove('is-dismissed'); setOpen(li, false); }
  });
  document.addEventListener('keydown', (e) => {
    const li = e.target.closest && e.target.closest(ITEM);
    if (!li) return;
    if (e.key === 'Escape') {
      li.classList.add('is-dismissed');
      setOpen(li, false);
      linkOf(li).focus();
    } else if ((e.key === 'Enter' || e.key === ' ') && e.target === linkOf(li) && li.classList.contains('is-dismissed')) {
      e.preventDefault();
      li.classList.remove('is-dismissed');
      setOpen(li, true);
    }
  });
})();

// Some page templates are built only from sections without an h1, so screen-reader users jumping by heading
// found no page title. Give them the page's own title as a visually hidden h1.
(() => {
  const addH1 = () => {
    const main = document.getElementById('main-content');
    if (!main || document.querySelector('h1')) return;
    const og = document.querySelector('meta[property="og:title"]');
    const h1 = document.createElement('h1');
    h1.className = 'visually-hidden';
    h1.textContent = ((og && og.content) || document.title.split('|')[0]).trim();
    main.prepend(h1);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addH1); else addH1();
})();

// Care+ covers one set per order. Moving it between cart lines: the cart's "Move Care+ to this set" / "Remove"
// (snippets/joyee-careplus-line.liquid) and the product page's "Move it to this set instead"
// (snippets/product-information.liquid). Runs on a click or after an add, never on a timer (/cart.js is rate limited).
// Each action reads the cart once first and sends every other property back exactly as the cart has it (Aris options
// included): the markup's copy can be out of date (Aris edits the line after the add) and Liquid escapes "&" in names.
(() => {
  const NAME = 'Joyee Care+';
  const drawer = document.getElementById('Cart-Drawer');
  // The last call of an action asks for the drawer markup too, so no separate refresh round trip is needed.
  const withSections = (body) => ({ ...body, sections: 'cart-drawer,cart-bubble', sections_url: window.location.pathname });
  const post = (url, body) => fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body)
  }).then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); });
  const readCart = () => fetch(`${theme.routes.cart_url || '/cart'}.js`, { cache: 'no-store' }).then((r) => r.json());
  const covered = (line) => (line.properties || {})[NAME] === 'Yes';
  // The key from the markup, else the same variant in the wanted Care+ state (keys change when Aris edits a line).
  const find = (cart, key, variant, care) => cart.items.find((l) => l.key === key)
    || cart.items.find((l) => String(l.variant_id) === String(variant) && covered(l) === care);
  const keep = (line) => Object.fromEntries(Object.entries(line.properties || {}).filter(([k, v]) => k !== NAME && v !== null && v !== ''));
  // Shopify ignores an empty properties object, so a set whose only property was Care+ is added again without it,
  // then the old line is removed. Add first: if anything fails, the set keeps Care+ instead of leaving the cart.
  // The product page's move and the clean-up below can both reach a line: a second run would add the set twice.
  const stripping = new Set();
  const strip = (line) => {
    if (stripping.has(line.key)) return Promise.resolve(null);
    stripping.add(line.key);
    const p = keep(line);
    const done = Object.keys(p).length
      ? post(theme.routes.cart_change_url, withSections({ id: line.key, quantity: line.quantity, properties: p }))
      : post(theme.routes.cart_add_url, { items: [{ id: line.variant_id, quantity: line.quantity }] })
        .then(() => post(theme.routes.cart_change_url, withSections({ id: line.key, quantity: 0 })));
    return done.catch((e) => { stripping.delete(line.key); throw e; });
  };
  // The product page's Care+ card was rendered with the old cart: re-render its section and swap the card in.
  const refreshCard = () => {
    const card = document.querySelector('[data-careplus-card]');
    const section = card && card.closest('[id^="shopify-section-"]');
    if (!section) return;
    fetch(`${window.location.pathname}?sections=${section.id.replace('shopify-section-', '')}`)
      .then((r) => r.json())
      .then((json) => {
        const fresh = new DOMParser().parseFromString(Object.values(json)[0] || '', 'text/html').querySelector('[data-careplus-card]');
        if (fresh) card.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  };
  const render = (state) => {
    // Only after a change that went through: a failed one would reload and try again forever.
    if (state && window.location.pathname.endsWith('/cart')) { window.location.reload(); return; }
    if (state && state.sections && drawer && drawer.getSectionsToRender) {
      drawer.getSectionsToRender().forEach((s) => {
        const el = document.getElementById(s.id);
        const html = el && drawer.getSectionInnerHTML(state.sections[s.section], s.selector);
        if (html !== null && html !== undefined) (el.querySelector(s.selector) || el).innerHTML = html;
      });
    } else {
      document.dispatchEvent(new Event('cart:refresh'));
    }
    refreshCard();
  };
  // Remove Care+ from a line (the "Remove" button, the product page's move, the clean-up below).
  window.joyeeCareplusStrip = (key, variant) => readCart()
    .then((cart) => { const line = find(cart, key, variant, true); return line && covered(line) ? strip(line) : null; })
    .catch(() => null)
    .then(render);

  // Moving Care+ to the set just added: only once that set is in the cart with Care+, not on any other add.
  window.joyeeCareplusMove = (key, variant) => readCart()
    .then((cart) => {
      const line = find(cart, key, variant, true);
      if (!line || !covered(line) || !cart.items.some((l) => l !== line && covered(l))) return false;
      return strip(line).catch(() => null).then(render).then(() => true);
    })
    .catch(() => false);

  // An older line still carrying Care+ is flagged .joyee-cp-stale by the cart markup: strip it, one at a time
  // (the redraw brings the next one). No flag on the page means no request. Each line is tried once.
  const tried = new Set();
  const sweep = () => {
    const s = document.querySelector('.joyee-cp-stale');
    if (!s || tried.has(s.dataset.from)) return false;
    tried.add(s.dataset.from);
    window.joyeeCareplusStrip(s.dataset.from, s.dataset.fromVariant);
    return true;
  };
  // An add-on line (Rush Order, Base Color) whose quantity no longer matches its set(s) is flagged .joyee-addon-fix
  // by the cart markup (snippets/joyee-addon-line.liquid): set it to that quantity, 0 once the set is gone. Same one-at-a-time rule.
  const fixAddon = () => {
    const f = document.querySelector('.joyee-addon-fix');
    const id = f && `${f.dataset.key}:${f.dataset.qty}`;
    if (!f || tried.has(id)) return;
    tried.add(id);
    post(theme.routes.cart_change_url, withSections({ id: f.dataset.key, quantity: Number(f.dataset.qty) })).catch(() => null).then(render);
  };
  const check = () => { if (!sweep()) fixAddon(); }; // one cart change at a time
  // The drawer and the cart page (#Cart) are both redrawn after a quantity change.
  [drawer, document.getElementById('Cart')].forEach((el) => { if (el) new MutationObserver(check).observe(el, { childList: true, subtree: true }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();

  document.addEventListener('click', (e) => {
    const off = e.target.closest && e.target.closest('.joyee-cp-remove');
    if (off && !off.disabled) {
      off.disabled = true;
      off.closest('.joyee-cp-line').style.opacity = '.4'; // fades at once; the server's markup then drops it
      window.joyeeCareplusStrip(off.dataset.from, off.dataset.fromVariant);
      return;
    }
    const btn = e.target.closest && e.target.closest('.joyee-cp-move');
    if (!btn || btn.disabled) return;
    const d = btn.dataset;
    // Never between two lines of the same variant: Shopify would merge them mid-move (the markup doesn't offer it either).
    if (d.toVariant === d.fromVariant) return;
    btn.disabled = true;
    // Show the result at once: swap the "covers this set" label and this button, then let the server's markup confirm it.
    const scope = btn.closest('.cart-drawer, form, main');
    const label = scope && scope.querySelector('.joyee-cp-line');
    if (label) {
      const mark = document.createComment('');
      btn.replaceWith(mark);
      label.replaceWith(btn);
      mark.replaceWith(label);
      label.querySelectorAll('button').forEach((b) => { b.disabled = true; });
    }
    // The set gaining Care+ goes first: changing a line's properties changes its key, and the other key must still be valid.
    readCart()
      .then((cart) => {
        const to = find(cart, d.to, d.toVariant, false);
        const from = find(cart, d.from, d.fromVariant, true);
        if (!to || !from) return null;
        return post(theme.routes.cart_change_url, { id: to.key, quantity: to.quantity, properties: { ...keep(to), [NAME]: 'Yes' } })
          .then(() => strip(from));
      })
      .catch(() => null)
      .then(render);
  });
})();
